import { X } from '@phosphor-icons/react'
import { Body, Box, Container, Header, Overlay } from './styles'
import React, { ReactNode } from 'react'

interface SideTabProps {
  title: string
  open: boolean | boolean
  toggleFunction: () => void
  children: ReactNode
  width?: string
}

export const SideTab = ({
  title,
  open,
  toggleFunction,
  children,
  width = '50%',
}: SideTabProps) => {
  if (!open) return null
  return (
    <>
      <Overlay onClick={toggleFunction} />
      <Container width={width}>
        <Box>
          <Header>
            <div>
              <p>{title}</p>
            </div>
            <div>
              <X
                size={32}
                color="#770A00"
                weight="bold"
                onClick={toggleFunction}
              />
            </div>
          </Header>
          <Body>{children}</Body>
        </Box>
      </Container>
    </>
  )
}
